export const _THEME = {
  color: {
    primary: {
      main: "#209cf1",
      accent1: "#f0f8ff",
      accent2: "#d8ecfd",
      accent3: "#209cf1",
      accent4: "#75c6fe",
    },
    accent: {
      main: "#333",
      accent1: "#7d99b1",
    },
    grey: {
      accent1: "#f1f1f1",
      accent2: "#e2e2e2",
      accent3: "#333333",
      accent4: "#555",
      accent5: "#919191",
      accent6: "#fdfdfd",
    },
    text: {
      main: "#1d1d1b",
      accent1: "#8f8f8f",
    },
    disabled: "#e1dfe9",
    black: "#000000",
    white: "#fff",
    green: "#3cb371",
    error: "#d73232",
    warning: "#faad14",
  },
  size: {
    sm: {
      1: "0.7rem",
      2: "0.8rem",
      3: "0.9rem",
    },
    md: {
      1: "1rem",
      2: "1.25rem",
      3: "1.5rem",
    },
    lg: {
      1: "2rem",
      2: "3rem",
      3: "4rem",
    },
  },
  shadow: {
    1: "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px",
    2: "rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px",
    3: "rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px",
    4: "0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3)",
    5: "0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
    6: "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -7px rgba(0, 0, 0, 0.2)",
    7: "0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2)",
    8: "0 22px 43px -20px rgba(0, 0, 0, 0.15)",
    9: "0 12px 23px -15px rgba(0, 0, 0, 0.15)",
  },
  spacing: (val) => 8 * val,
};

export const mainColor = _THEME.color.primary.main;
export const errorColor = _THEME.color.error;
export const mainColor2 = _THEME.color.primary.accent1;
export const mainColor3 = _THEME.color.primary.accent2;
export const accentColor = _THEME.color.accent.main;
export const accentColor2 = _THEME.color.accent.accent1;
export const greenColor = _THEME.color.green;
export const warningColor = _THEME.color.warning;
export const sm1 = _THEME.size.sm[1];
export const sm2 = _THEME.size.sm[2];
export const sm3 = _THEME.size.sm[3];
export const md1 = _THEME.size.md[1];
export const md2 = _THEME.size.md[2];
export const md3 = _THEME.size.md[3];
export const lg1 = _THEME.size.lg[1];
export const lg2 = _THEME.size.lg[2];
export const lg3 = _THEME.size.lg[3];
export const shadow1 = _THEME.shadow[1];
export const shadow2 = _THEME.shadow[2];
export const shadow3 = _THEME.shadow[3];
export const shadow4 = _THEME.shadow[4];
export const shadow5 = _THEME.shadow[5];
export const shadow6 = _THEME.shadow[6];
export const shadow7 = _THEME.shadow[7];
export const shadow8 = _THEME.shadow[8];
export const shadow9 = _THEME.shadow[9];
export const grey1 = _THEME.color.grey.accent1;
export const grey2 = _THEME.color.grey.accent2;
export const grey3 = _THEME.color.grey.accent3;
export const grey4 = _THEME.color.grey.accent4;
export const grey5 = _THEME.color.grey.accent5;
export const grey6 = _THEME.color.grey.accent6;
export const white = _THEME.color.white;

export const mobileQuery = "@media only screen and (max-width: 600px)";
export const tabQuery = "@media only screen and (max-width: 992px)";
export const deskQuery = "@media only screen and (min-width: 993px)";
